import {
  GET_OFFER_DETAILS,
  GET_OFFER_DETAILS_SUCCESS,
  GET_TEMPLATE_DETAILS,
  GET_TEMPLATE_DETAILS_SUCCESS,
  OFFER_COMMON_ERROR,
  OFFER_COMMON_SUCCESS,
  REVOKE_OFFER_LETTER,
  SAVE_OFFER_DETAILS,
  SHOW_OFFER_LETTER,SHOW_OFFER_LETTER_SUCCESS,SHOW_OFFER_LETTER_FAILED
} from "./actionTypes";
// get offer details
export const getOfferDetails = (jobId, candidateId) => {
  return {
    type: GET_OFFER_DETAILS,
    payload: { jobId, candidateId },
  };
};
export const getOfferDetailsSuccess = (success) => {
  return {
    type: GET_OFFER_DETAILS_SUCCESS,
    payload: success,
  };
};

//save offer details
export const saveOfferDetails = (data) => {
  return {
    type: SAVE_OFFER_DETAILS,
    payload: { data },
  };
};
//get template data
export const getTemplateLetterData = (data) => {
  return {
    type: GET_TEMPLATE_DETAILS,
    payload: { data },
  };
};

export const getTemplateLetterDataSuccess = (list) => {
  return {
    type: GET_TEMPLATE_DETAILS_SUCCESS,
    payload: list,
  };
};
//edit offer letter
export const revokeOfferLetter = (id) => {
  return {
    type: REVOKE_OFFER_LETTER,
    payload: { id },
  };
};

export const offerCommonSuccess = (data) => {
  return {
    type: OFFER_COMMON_SUCCESS,
    payload: data,
  };
};

export const offerCommonError = (data) => {
  return {
    type: OFFER_COMMON_ERROR,
    payload:data,
  };
};

export const showOfferLetter=(data)=>{
  return{
      type:SHOW_OFFER_LETTER,
      payload:data
  }
}

export const showOfferLetterSuccess=(data)=>{
  return{
      type:SHOW_OFFER_LETTER_SUCCESS,
      payload:data
  }

}

export const showOfferLetterFailed=(error)=>{
  return{
      type:SHOW_OFFER_LETTER_FAILED,
      payload:error
  }

}